import axios from 'axios';
import verifyDatas from '../views/verifyDatas';
import url from './Url';

class userAndCompanyRegister extends url {
    constructor() { super() }

    seachByCep = (cep) => {
        if (verifyDatas.isValid(cep)) {
            let data = { cep: cep };

            return axios.post(`${this.url()}/address`, data)
                .then(newAddress =>
                    newAddress
                )
                .catch(err => err);
        } else {
            return Promise.reject({ message: "Insira um Valor válido" });
        }
    };
 

    addUserAndCompany = (datas) => {
        console.log(datas)
        return axios.post(`${this.url()}/user`, datas)
            .then(response => {
                return response
            })
            .catch(err => {
                return err
            })
    }

}
export default userAndCompanyRegister;
